module.exports = __webpack_public_path__ + "static/media/banner-harineraguadalupe.a6bb8baa.jpg";